/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
} from 'restful-react'
import { IShipmentIssueTypeSlaBasedOn } from 'types/graphqlTypes'

export const SPEC_VERSION = 'v9'
export interface ShipmentIssue {
  id: number
  shipmentId: number
  shipmentIssueType: {
    id: number
    name: string
    category: string
  }
  shipmentIssueReason: {
    id: number
    reason: string
  }
  shipmentIssueFault: {
    id: number
    fault: string
  }
  summary?: string | null
  priority?: number | null
  state: string
  dueAt?: string | null
  lastStateTransition?: string | null
  createdBy: User
  updatedBy: User
  createdAt: string
  updatedAt: string
  shipmentIssueOwner?: ShipmentIssueOwner
  shipmentIssueSubscribers?: ShipmentIssueSubscriber[]
}

export interface ShipmentIssueCreate {
  shipmentIssueTypeId: number
  shipmentIssueReasonId?: number
  shipmentIssueFaultId: number
  summary?: string
  priority?: number
  state: string
  dueAt?: string
  owner: ShipmentIssueOwnerCreate
  subscribers?: ShipmentIssueSubscriberCreate[]
}

export interface ShipmentIssueUpdate {
  shipmentIssueTypeId?: number
  shipmentIssueReasonId?: number
  shipmentIssueFaultId?: number
  summary?: string
  priority?: number
  state?: string
  dueAt?: string
  owner?: ShipmentIssueOwnerCreate
  subscribers?: ShipmentIssueSubscriberCreate[]
}

export interface ShipmentIssueSuggestedOwner {
  ownerType: string
  ownerId: number
  firstName: string
  lastName: string
  nickname: string
  role: string
}

export interface DefaultAssignee {
  id: number
  type: string
  firstName: string
  lastName: string
  nickname: string
}

export interface ShipmentIssueOwner {
  id: number
  shipmentIssueId: number
  nickname: string
  firstName: string
  lastName: string
  ownerType: string
  ownerId: number
}

export interface ShipmentIssueOwnerCreate {
  type: string
  id: number
}

export interface ShipmentIssueSubscriber {
  id: number
  shipmentIssueId: number
  nickname: string
  firstName: string
  lastName: string
  subscriberType: string
  subscriberId: number
  createdAt?: string
  updatedAt?: string
  deletedAt?: string | null
}

export interface ShipmentIssueSubscriberCreate {
  type: string
  id: number
}

export interface ShipmentIssueAssigneeRole {
  id: number
  type: string
  role: string
}

export interface ShipmentIssueFault {
  id: number
  fault: string
  createdAt?: string
  updatedAt?: string
  deletedAt?: string | null
  createdById?: number
  updatedById?: number
  deletedById?: number | null
}

export interface ShipmentIssueReason {
  id: number
  reason: string
  createdAt?: string
  updatedAt?: string
  deletedAt?: string | null
  createdById?: number
  updatedById?: number
  deletedById?: number | null
}

export interface IIssueResolutionSteps {
  id: string
  description: string
  stepSequence: number
  deletedAt?: string
}

export interface ShipmentIssueType {
  id: number
  name: string
  deletable: boolean
  description?: string | null
  stepsToResolve?: string[] | null
  issueResolutionSteps?: IIssueResolutionSteps[] | null
  defaultPriority?: number | null
  shipmentIssueCategoryId?: number
  autoResolve?: boolean
  createdAt?: string
  updatedAt?: string
  createdBy?: User
  updatedBy?: User
  shipmentIssueTypeDefaultOwner?: ShipmentIssueTypeDefaultOwner
  shipmentIssueTypeDefaultSubscribers?: ShipmentIssueTypeDefaultSubscriber[]
  slaBasedOn: IShipmentIssueTypeSlaBasedOn
  slaDuration: number
}

export type ShipmentIssueTypeDefaultOwner = {
  id: number
  shipmentIssueTypeId: number
  ownerType: string
  ownerId: number
  firstName: string
  lastName?: string
  nickname?: string
} | null

export interface ShipmentIssueTypeDefaultSubscriber {
  id: number
  shipmentIssueTypeId: number
  subscriberType: string
  subscriberId: number
  createdAt?: string
  updatedAt?: string
  firstName: string
  lastName?: string
  nickname?: string
}

export type ShipmentIssueTypeOwner = {
  id: number
  shipmentIssueTypeId: number
  nickname: string
  firstName: string
  lastName: string
  ownerType: string
  ownerId: number
} | null

export interface ShipmentIssueTypeSubscriber {
  id: number
  shipmentIssueTypeId: number
  nickname: string
  firstName: string
  lastName: string
  subscriberType: string
  subscriberId: number
  createdAt?: string
  updatedAt?: string
}

export interface ShipmentIssueTypeCreate {
  shipmentIssueCategoryId: number
  name: string
  description: string
  defaultPriority?: number
  autoResolve?: boolean
  shipmentIssueTypeDefaultOwner?: ShipmentIssueTypeOwnerCreate
  shipmentIssueTypeDefaultSubscribers?: ShipmentIssueTypeSubscriberCreate[]
}

export interface ShipmentIssueTypeUpdate {
  shipmentIssueCategoryId?: number
  name?: string
  description?: string
  defaultPriority?: number
  autoResolve?: boolean
  shipmentIssueTypeDefaultOwner?: ShipmentIssueTypeOwnerCreate
  shipmentIssueTypeDefaultSubscribers?: ShipmentIssueTypeSubscriberCreate[]
}

export interface ShipmentIssueTypeOwnerCreate {
  type: string
  id: number
}

export interface ShipmentIssueTypeSubscriberCreate {
  type: string
  id: number
}

export interface ShipmentIssueCategory {
  id: number
  name: string
  createdAt?: string
  updatedAt?: string
  deletedAt?: string | null
  createdById?: number
  updatedById?: number
  deletedById?: number | null
}

export interface User {
  id: number
  firstName: string
  lastName?: string
}

export interface ErrorResponse {
  errors: string[]
}

export interface GetShipmentIssuesResponse {
  shipmentIssues?: ShipmentIssue[]
}

export interface GetShipmentIssuesQueryParams {
  /**
   * Filters applied to results
   */
  filters?: { [key: string]: any }
}

export interface GetShipmentIssuesPathParams {
  /**
   * Shipment Id
   */
  shipmentId: number
}

export type GetShipmentIssuesProps = Omit<
  GetProps<
    GetShipmentIssuesResponse,
    ErrorResponse,
    GetShipmentIssuesQueryParams,
    GetShipmentIssuesPathParams
  >,
  'path'
> &
  GetShipmentIssuesPathParams

/**
 * Shipment Issues List
 */
export const GetShipmentIssues = ({ shipmentId, ...props }: GetShipmentIssuesProps) => (
  <Get<
    GetShipmentIssuesResponse,
    ErrorResponse,
    GetShipmentIssuesQueryParams,
    GetShipmentIssuesPathParams
  >
    path={`/v9/shipments/${shipmentId}/issues`}
    {...props}
  />
)

export type UseGetShipmentIssuesProps = Omit<
  UseGetProps<
    GetShipmentIssuesResponse,
    ErrorResponse,
    GetShipmentIssuesQueryParams,
    GetShipmentIssuesPathParams
  >,
  'path'
> &
  GetShipmentIssuesPathParams

/**
 * Shipment Issues List
 */
export const useGetShipmentIssues = ({ shipmentId, ...props }: UseGetShipmentIssuesProps) =>
  useGet<
    GetShipmentIssuesResponse,
    ErrorResponse,
    GetShipmentIssuesQueryParams,
    GetShipmentIssuesPathParams
  >(
    (paramsInPath: GetShipmentIssuesPathParams) =>
      `/v9/shipments/${paramsInPath.shipmentId}/issues`,
    { pathParams: { shipmentId }, ...props }
  )

export interface CreateShipmentIssuePathParams {
  /**
   * Shipment Id
   */
  shipmentId: number
}

export type CreateShipmentIssueProps = Omit<
  MutateProps<ShipmentIssue, unknown, void, ShipmentIssueCreate, CreateShipmentIssuePathParams>,
  'path' | 'verb'
> &
  CreateShipmentIssuePathParams

/**
 * Shipment Issue
 */
export const CreateShipmentIssue = ({ shipmentId, ...props }: CreateShipmentIssueProps) => (
  <Mutate<ShipmentIssue, unknown, void, ShipmentIssueCreate, CreateShipmentIssuePathParams>
    verb='POST'
    path={`/v9/shipments/${shipmentId}/issues`}
    {...props}
  />
)

export type UseCreateShipmentIssueProps = Omit<
  UseMutateProps<ShipmentIssue, unknown, void, ShipmentIssueCreate, CreateShipmentIssuePathParams>,
  'path' | 'verb'
> &
  CreateShipmentIssuePathParams

/**
 * Shipment Issue
 */
export const useCreateShipmentIssue = ({ shipmentId, ...props }: UseCreateShipmentIssueProps) =>
  useMutate<ShipmentIssue, unknown, void, ShipmentIssueCreate, CreateShipmentIssuePathParams>(
    'POST',
    (paramsInPath: CreateShipmentIssuePathParams) =>
      `/v9/shipments/${paramsInPath.shipmentId}/issues`,
    { pathParams: { shipmentId }, ...props }
  )

export interface GetShipmentIssuePathParams {
  /**
   * Shipment Id
   */
  shipmentId: number
  /**
   * Issue Id
   */
  id: number
}

export type GetShipmentIssueProps = Omit<
  GetProps<ShipmentIssue, ErrorResponse, void, GetShipmentIssuePathParams>,
  'path'
> &
  GetShipmentIssuePathParams

/**
 * Shipment Issue
 */
export const GetShipmentIssue = ({ id, shipmentId, ...props }: GetShipmentIssueProps) => (
  <Get<ShipmentIssue, ErrorResponse, void, GetShipmentIssuePathParams>
    path={`/v9/shipments/${shipmentId}/issues/${id}`}
    {...props}
  />
)

export type UseGetShipmentIssueProps = Omit<
  UseGetProps<ShipmentIssue, ErrorResponse, void, GetShipmentIssuePathParams>,
  'path'
> &
  GetShipmentIssuePathParams

/**
 * Shipment Issue
 */
export const useGetShipmentIssue = ({ id, shipmentId, ...props }: UseGetShipmentIssueProps) =>
  useGet<ShipmentIssue, ErrorResponse, void, GetShipmentIssuePathParams>(
    (paramsInPath: GetShipmentIssuePathParams) =>
      `/v9/shipments/${paramsInPath.shipmentId}/issues/${paramsInPath.id}`,
    { pathParams: { shipmentId, id }, ...props }
  )

export interface UpdateShipmentIssuePathParams {
  /**
   * Shipment Id
   */
  shipmentId: number
  /**
   * Issue Id
   */
  id: number
}

export type UpdateShipmentIssueProps = Omit<
  MutateProps<ShipmentIssue, unknown, void, ShipmentIssueUpdate, UpdateShipmentIssuePathParams>,
  'path' | 'verb'
> &
  UpdateShipmentIssuePathParams

/**
 * Shipment Issue
 */
export const UpdateShipmentIssue = ({ id, shipmentId, ...props }: UpdateShipmentIssueProps) => (
  <Mutate<ShipmentIssue, unknown, void, ShipmentIssueUpdate, UpdateShipmentIssuePathParams>
    verb='PUT'
    path={`/v9/shipments/${shipmentId}/issues/${id}`}
    {...props}
  />
)

export type UseUpdateShipmentIssueProps = Omit<
  UseMutateProps<ShipmentIssue, unknown, void, ShipmentIssueUpdate, UpdateShipmentIssuePathParams>,
  'path' | 'verb'
> &
  UpdateShipmentIssuePathParams

/**
 * Shipment Issue
 */
export const useUpdateShipmentIssue = ({ id, shipmentId, ...props }: UseUpdateShipmentIssueProps) =>
  useMutate<ShipmentIssue, unknown, void, ShipmentIssueUpdate, UpdateShipmentIssuePathParams>(
    'PUT',
    (paramsInPath: UpdateShipmentIssuePathParams) =>
      `/v9/shipments/${paramsInPath.shipmentId}/issues/${paramsInPath.id}`,
    { pathParams: { shipmentId, id }, ...props }
  )

export interface DeleteShipmentIssueSubscriberPathParams {
  /**
   * Shipment Id
   */
  shipmentId: number
  /**
   * Issue Id
   */
  issueId: number
}

export type DeleteShipmentIssueSubscriberProps = Omit<
  MutateProps<void, unknown, void, number, DeleteShipmentIssueSubscriberPathParams>,
  'path' | 'verb'
> &
  DeleteShipmentIssueSubscriberPathParams

/**
 * Shipment Issue Subscriber
 */
export const DeleteShipmentIssueSubscriber = ({
  issueId,
  shipmentId,
  ...props
}: DeleteShipmentIssueSubscriberProps) => (
  <Mutate<void, unknown, void, number, DeleteShipmentIssueSubscriberPathParams>
    verb='DELETE'
    path={`/v9/shipments/${shipmentId}/issues/${issueId}/subscribers`}
    {...props}
  />
)

export type UseDeleteShipmentIssueSubscriberProps = Omit<
  UseMutateProps<void, unknown, void, number, DeleteShipmentIssueSubscriberPathParams>,
  'path' | 'verb'
> &
  DeleteShipmentIssueSubscriberPathParams

/**
 * Shipment Issue Subscriber
 */
export const useDeleteShipmentIssueSubscriber = ({
  issueId,
  shipmentId,
  ...props
}: UseDeleteShipmentIssueSubscriberProps) =>
  useMutate<void, unknown, void, number, DeleteShipmentIssueSubscriberPathParams>(
    'DELETE',
    (paramsInPath: DeleteShipmentIssueSubscriberPathParams) =>
      `/v9/shipments/${paramsInPath.shipmentId}/issues/${paramsInPath.issueId}/subscribers`,
    { pathParams: { shipmentId, issueId }, ...props }
  )

export interface GetShipmentSuggestedIssueOwnersResponse {
  shipmentIssueSuggestedOwners?: ShipmentIssueSuggestedOwner[]
}

export interface GetShipmentSuggestedIssueOwnersPathParams {
  /**
   * Shipment Id
   */
  id: number
}

export type GetShipmentSuggestedIssueOwnersProps = Omit<
  GetProps<
    GetShipmentSuggestedIssueOwnersResponse,
    ErrorResponse,
    void,
    GetShipmentSuggestedIssueOwnersPathParams
  >,
  'path'
> &
  GetShipmentSuggestedIssueOwnersPathParams

/**
 * Shipment Suggested Issue Owners
 */
export const GetShipmentSuggestedIssueOwners = ({
  id,
  ...props
}: GetShipmentSuggestedIssueOwnersProps) => (
  <Get<
    GetShipmentSuggestedIssueOwnersResponse,
    ErrorResponse,
    void,
    GetShipmentSuggestedIssueOwnersPathParams
  >
    path={`/v9/shipments/${id}/suggested_issue_owners`}
    {...props}
  />
)

export type UseGetShipmentSuggestedIssueOwnersProps = Omit<
  UseGetProps<
    GetShipmentSuggestedIssueOwnersResponse,
    ErrorResponse,
    void,
    GetShipmentSuggestedIssueOwnersPathParams
  >,
  'path'
> &
  GetShipmentSuggestedIssueOwnersPathParams

/**
 * Shipment Suggested Issue Owners
 */
export const useGetShipmentSuggestedIssueOwners = ({
  id,
  ...props
}: UseGetShipmentSuggestedIssueOwnersProps) =>
  useGet<
    GetShipmentSuggestedIssueOwnersResponse,
    ErrorResponse,
    void,
    GetShipmentSuggestedIssueOwnersPathParams
  >(
    (paramsInPath: GetShipmentSuggestedIssueOwnersPathParams) =>
      `/v9/shipments/${paramsInPath.id}/suggested_issue_owners`,
    { pathParams: { id }, ...props }
  )

export interface GetShipmentIssueFaultsResponse {
  shipmentIssueFaults?: ShipmentIssueFault[]
}

export type GetShipmentIssueFaultsProps = Omit<
  GetProps<GetShipmentIssueFaultsResponse, ErrorResponse, void, void>,
  'path'
>

/**
 * Shipment Issue Faults
 */
export const GetShipmentIssueFaults = (props: GetShipmentIssueFaultsProps) => (
  <Get<GetShipmentIssueFaultsResponse, ErrorResponse, void, void>
    path='/v9/shipment_issue_faults'
    {...props}
  />
)

export type UseGetShipmentIssueFaultsProps = Omit<
  UseGetProps<GetShipmentIssueFaultsResponse, ErrorResponse, void, void>,
  'path'
>

/**
 * Shipment Issue Faults
 */
export const useGetShipmentIssueFaults = (props: UseGetShipmentIssueFaultsProps) =>
  useGet<GetShipmentIssueFaultsResponse, ErrorResponse, void, void>(
    `/v9/shipment_issue_faults`,
    props
  )

export interface GetShipmentIssueReasonsResponse {
  shipmentIssueReasons?: ShipmentIssueReason[]
}

export type GetShipmentIssueReasonsProps = Omit<
  GetProps<GetShipmentIssueReasonsResponse, ErrorResponse, void, void>,
  'path'
>

/**
 * Shipment Issue Reasons
 */
export const GetShipmentIssueReasons = (props: GetShipmentIssueReasonsProps) => (
  <Get<GetShipmentIssueReasonsResponse, ErrorResponse, void, void>
    path='/v9/shipment_issue_reasons'
    {...props}
  />
)

export type UseGetShipmentIssueReasonsProps = Omit<
  UseGetProps<GetShipmentIssueReasonsResponse, ErrorResponse, void, void>,
  'path'
>

/**
 * Shipment Issue Reasons
 */
export const useGetShipmentIssueReasons = (props: UseGetShipmentIssueReasonsProps) =>
  useGet<GetShipmentIssueReasonsResponse, ErrorResponse, void, void>(
    `/v9/shipment_issue_reasons`,
    props
  )

export interface GetShipmentIssueTypesResponse {
  shipmentIssueTypes?: ShipmentIssueType[]
}

export type GetShipmentIssueTypesProps = Omit<
  GetProps<GetShipmentIssueTypesResponse, ErrorResponse, void, void>,
  'path'
>

/**
 * Shipment Issue Types
 */
export const GetShipmentIssueTypes = (props: GetShipmentIssueTypesProps) => (
  <Get<GetShipmentIssueTypesResponse, ErrorResponse, void, void>
    path='/v9/shipment_issue_types'
    {...props}
  />
)

export type UseGetShipmentIssueTypesProps = Omit<
  UseGetProps<GetShipmentIssueTypesResponse, ErrorResponse, void, void>,
  'path'
>

/**
 * Shipment Issue Types
 */
export const useGetShipmentIssueTypes = (props: UseGetShipmentIssueTypesProps) =>
  useGet<GetShipmentIssueTypesResponse, ErrorResponse, void, void>(
    `/v9/shipment_issue_types`,
    props
  )

export type CreateShipmentIssueTypeProps = Omit<
  MutateProps<ShipmentIssueType, unknown, void, ShipmentIssueTypeCreate, void>,
  'path' | 'verb'
>

/**
 * Shipment Issue Type
 */
export const CreateShipmentIssueType = (props: CreateShipmentIssueTypeProps) => (
  <Mutate<ShipmentIssueType, unknown, void, ShipmentIssueTypeCreate, void>
    verb='POST'
    path='/v9/shipment_issue_types'
    {...props}
  />
)

export type UseCreateShipmentIssueTypeProps = Omit<
  UseMutateProps<ShipmentIssueType, unknown, void, ShipmentIssueTypeCreate, void>,
  'path' | 'verb'
>

/**
 * Shipment Issue Type
 */
export const useCreateShipmentIssueType = (props: UseCreateShipmentIssueTypeProps) =>
  useMutate<ShipmentIssueType, unknown, void, ShipmentIssueTypeCreate, void>(
    'POST',
    `/v9/shipment_issue_types`,
    props
  )

export interface UpdateShipmentIssueTypePathParams {
  /**
   * issueTypeId
   */
  id: number
}

export type UpdateShipmentIssueTypeProps = Omit<
  MutateProps<
    ShipmentIssueType,
    unknown,
    void,
    ShipmentIssueTypeUpdate,
    UpdateShipmentIssueTypePathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentIssueTypePathParams

/**
 * Shipment Issue Type
 */
export const UpdateShipmentIssueType = ({ id, ...props }: UpdateShipmentIssueTypeProps) => (
  <Mutate<
    ShipmentIssueType,
    unknown,
    void,
    ShipmentIssueTypeUpdate,
    UpdateShipmentIssueTypePathParams
  >
    verb='PUT'
    path={`/v9/shipment_issue_types/${id}`}
    {...props}
  />
)

export type UseUpdateShipmentIssueTypeProps = Omit<
  UseMutateProps<
    ShipmentIssueType,
    unknown,
    void,
    ShipmentIssueTypeUpdate,
    UpdateShipmentIssueTypePathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentIssueTypePathParams

/**
 * Shipment Issue Type
 */
export const useUpdateShipmentIssueType = ({ id, ...props }: UseUpdateShipmentIssueTypeProps) =>
  useMutate<
    ShipmentIssueType,
    unknown,
    void,
    ShipmentIssueTypeUpdate,
    UpdateShipmentIssueTypePathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipmentIssueTypePathParams) =>
      `/v9/shipment_issue_types/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export type DeleteShipmentIssueTypeProps = Omit<
  MutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Shipment Issue Type
 */
export const DeleteShipmentIssueType = (props: DeleteShipmentIssueTypeProps) => (
  <Mutate<void, unknown, void, number, void>
    verb='DELETE'
    path='/v9/shipment_issue_types'
    {...props}
  />
)

export type UseDeleteShipmentIssueTypeProps = Omit<
  UseMutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Shipment Issue Type
 */
export const useDeleteShipmentIssueType = (props: UseDeleteShipmentIssueTypeProps) =>
  useMutate<void, unknown, void, number, void>('DELETE', `/v9/shipment_issue_types`, { ...props })

export type GetShipmentIssueDefaultsResponse = {
  shipmentIssueTypeDefaultOwner?: DefaultAssignee
  shipmentIssueTypeDefaultSubscribers?: DefaultAssignee[]
  defaultPriority?: number | null
}

export interface GetShipmentIssueDefaultsQueryParams {
  /**
   * Filters applied to results
   */
  filters: { [key: string]: any }
}

export interface GetShipmentIssueDefaultsPathParams {
  /**
   * Shipment Id
   */
  shipmentId: number
}

export type GetShipmentIssueDefaultsProps = Omit<
  GetProps<
    GetShipmentIssueDefaultsResponse,
    unknown,
    GetShipmentIssueDefaultsQueryParams,
    GetShipmentIssueDefaultsPathParams
  >,
  'path'
> &
  GetShipmentIssueDefaultsPathParams

/**
 * Issue Defaults
 */
export const GetShipmentIssueDefaults = ({
  shipmentId,
  ...props
}: GetShipmentIssueDefaultsProps) => (
  <Get<
    GetShipmentIssueDefaultsResponse,
    unknown,
    GetShipmentIssueDefaultsQueryParams,
    GetShipmentIssueDefaultsPathParams
  >
    path={`/v9/shipments/${shipmentId}/issues/defaults`}
    {...props}
  />
)

export type UseGetShipmentIssueDefaultsProps = Omit<
  UseGetProps<
    GetShipmentIssueDefaultsResponse,
    unknown,
    GetShipmentIssueDefaultsQueryParams,
    GetShipmentIssueDefaultsPathParams
  >,
  'path'
> &
  GetShipmentIssueDefaultsPathParams

/**
 * Issue Defaults
 */
export const useGetShipmentIssueDefaults = ({
  shipmentId,
  ...props
}: UseGetShipmentIssueDefaultsProps) =>
  useGet<
    GetShipmentIssueDefaultsResponse,
    unknown,
    GetShipmentIssueDefaultsQueryParams,
    GetShipmentIssueDefaultsPathParams
  >(
    (paramsInPath: GetShipmentIssueDefaultsPathParams) =>
      `/v9/shipments/${paramsInPath.shipmentId}/issues/defaults`,
    { pathParams: { shipmentId }, ...props }
  )

export interface GetShipmentIssueCategoriesResponse {
  shipmentIssueCategories?: ShipmentIssueCategory[]
}

export type GetShipmentIssueCategoriesProps = Omit<
  GetProps<GetShipmentIssueCategoriesResponse, ErrorResponse, void, void>,
  'path'
>

/**
 * Shipment Issue Categories
 */
export const GetShipmentIssueCategories = (props: GetShipmentIssueCategoriesProps) => (
  <Get<GetShipmentIssueCategoriesResponse, ErrorResponse, void, void>
    path='/v9/shipment_issue_categories'
    {...props}
  />
)

export type UseGetShipmentIssueCategoriesProps = Omit<
  UseGetProps<GetShipmentIssueCategoriesResponse, ErrorResponse, void, void>,
  'path'
>

/**
 * Shipment Issue Categories
 */
export const useGetShipmentIssueCategories = (props: UseGetShipmentIssueCategoriesProps) =>
  useGet<GetShipmentIssueCategoriesResponse, ErrorResponse, void, void>(
    `/v9/shipment_issue_categories`,
    props
  )

export interface GetShipmentIssueAssigneeRolesResponse {
  shipmentIssueAssigneeRoles?: ShipmentIssueAssigneeRole[]
}

export type GetShipmentIssueAssigneeRolesProps = Omit<
  GetProps<GetShipmentIssueAssigneeRolesResponse, ErrorResponse, void, void>,
  'path'
>

/**
 * Shipment Issue Assignee Roles
 */
export const GetShipmentIssueAssigneeRoles = (props: GetShipmentIssueAssigneeRolesProps) => (
  <Get<GetShipmentIssueAssigneeRolesResponse, ErrorResponse, void, void>
    path='/v9/shipment_issue_assignee_roles'
    {...props}
  />
)

export type UseGetShipmentIssueAssigneeRolesProps = Omit<
  UseGetProps<GetShipmentIssueAssigneeRolesResponse, ErrorResponse, void, void>,
  'path'
>

/**
 * Shipment Issue Assignee Roles
 */
export const useGetShipmentIssueAssigneeRoles = (props: UseGetShipmentIssueAssigneeRolesProps) =>
  useGet<GetShipmentIssueAssigneeRolesResponse, ErrorResponse, void, void>(
    `/v9/shipment_issue_assignee_roles`,
    props
  )
